import React, { useEffect, useRef, useState } from 'react'
import './verify-email.styles.scss';
import UnauthLayout from '@/components/layout-unauth/unauth-layout.component'
import ThreeDotsLoader from '@/components/loader/three-dots-loader.component'
import { ModalAlert } from '@/components/modal/modal.component'
import { UseCloudFunction } from '@/utils/firebase.utils'
import { useNavigate } from 'react-router-dom';

const VerifyEmailPage = () => {

    const [ alertMessage, setAlertMessage ] = useState(null);
    const [ loading, setLoading ] = useState(true);
    const [ noEmail, setNoEmail ] = useState(false);
    const approveRef = useRef();
    const navigate = useNavigate();

    useEffect(() => {
        const email = localStorage.getItem('emailToVerify');
        if (!email) {
            setNoEmail(true);
            setLoading(false);
            return;
        }
        sendEmailVerification();
    }, [])

    async function sendEmailVerification(e) {
        let email = localStorage.getItem('emailToVerify');

        if (e === 'form') {
            let email = document.getElementById('email').value.toLowerCase().replace(/\s+/g, '');
            if (!email.includes('@') || !email.includes('.')) {
                setAlertMessage('Please enter a valid email address.');
                return;
            }
            
        }
        if (e !== 'form' && !email) {
            setNoEmail(true);
            return;
        }
        setLoading(true);
        const res = await UseCloudFunction(
            'sendEmailVerificationEmail',
            { 'userEmail': email }
        )
        setLoading(false);
        if (res.error) {
            setAlertMessage(`Something went wrong. Please try again. (Error: ${res.error})`);
            return;
        }
        approveRef.current = () => {
            navigate('/signin')
        }
    }

    return (
        <div className='verify-email-page'>
            <UnauthLayout>
                <div className='verify-email-page__container g-card'>
                    <div className='card-title'>Verify Email</div>
                    <hr />
                    {
                        (loading)
                        ?
                        <div>
                            <div className="center-col">
                                <ThreeDotsLoader />
                            </div>
                        </div>
                        :
                        (noEmail)
                        ?
                        <div>
                            <p>Please enter your email address below to receive a verification email.</p>
                            <div className='field'>
                                <input
                                    type='email'
                                    id='email'
                                    placeholder='joe@email.com...' />
                            </div>
                            <div className="g-space-1"></div>
                            <div className='buttons'>
                                <button className='g-button' onClick={() => {sendEmailVerification('form')}}>Send Verification Email</button>
                            </div>
                        </div>
                        :
                        <div>
                            <p>Please check your email inbox for a verification link. 
                                If you don't see the email, please check your spam folder. 
                                Click the link in the email to verify your account.</p>
                            <p>If you didn't receive the email, please click the button below to resend it.</p>
                            <div className="g-space-1"></div>
                            <div className='buttons'>
                                <button 
                                    className='g-button text-only left-item' 
                                    onClick={() => {sendEmailVerification()}}>
                                    Resend Verification Email
                                </button>
                                <button 
                                    className='g-button'
                                    onClick={() => {navigate('/signin')}}>
                                    Sign In
                                </button>
                            </div>
                        </div>
                    }
                </div>
            </UnauthLayout>
            <ModalAlert
                show={alertMessage}
                cancel={() => setAlertMessage(null)}
                message={alertMessage}
                onApprove={approveRef.current} />
        </div>
    )
}

export default VerifyEmailPage